import { FC } from 'react';
import { MovingGradient } from '../../../../components/MovingGradient';
import { ColumnsBalancer } from '../../../../components/ColumnsBalancer';
import ControlGroup, { ControlGroupRow } from '../../../../components/ControlGroup';
import { isMobileAny } from '../../../../utils/device';
import { isUndefined } from '../../../../predicates/type';
import { DetailPageTabFormSection } from '../DetailPageTabFormSection';
import { getRandomBoundary } from '../../../list/listPage/ListLoadingPlaceholder/utils';

type DetailPageTabPlaceholderProps = {
	fieldsCount?: number;
	sectionsFieldsCount?: number[];
};

function Section({ fieldsCount }: { fieldsCount: number }) {
	const fields = Array.from(Array(fieldsCount).keys());

	return (
		<ColumnsBalancer>
			{fields.map((field) => {
				const isDoubleField = Math.floor(Math.random() * 5) === 4;
				const isSingleColumn = isDoubleField && Math.floor(Math.random() * 6) === 2;
				const titleWidthColumn1 = isDoubleField ? getRandomBoundary(50, 100) : getRandomBoundary(100, 220);

				return (
					<ControlGroupRow
						key={`placeholder_${field}`}
						grid={isDoubleField ? '3-3' : '6'}
					>
						<ControlGroup
							labelWFull
							label={
								<MovingGradient
									height='16px'
									width={titleWidthColumn1}
								/>
							}
						>
							<MovingGradient
								height='32px'
								width='100%'
							/>
						</ControlGroup>
						{isDoubleField && isSingleColumn && (
							<ControlGroup
								labelWFull
								label={
									<MovingGradient
										height='16px'
										width='100%'
									/>
								}
							>
								<MovingGradient
									height='32px'
									width='100%'
								/>
							</ControlGroup>
						)}
					</ControlGroupRow>
				);
			})}
		</ColumnsBalancer>
	);
}

const DetailPageTabPlaceholder: FC<DetailPageTabPlaceholderProps> = ({
	fieldsCount = isMobileAny ? 12 : 30,
	sectionsFieldsCount,
}) => {
	if (isUndefined(sectionsFieldsCount)) {
		return <Section fieldsCount={fieldsCount} />;
	}

	const sections = Array.from(Array(sectionsFieldsCount.length).keys());

	return (
		<>
			{sections.map((_, index) => {
				const contentWidth = Math.random() * (220 - 80) + 80;

				return (
					<DetailPageTabFormSection
						key={index}
						title={
							<MovingGradient
								height='16px'
								width={`${contentWidth}px`}
							/>
						}
					>
						<Section fieldsCount={sectionsFieldsCount[index]} />
					</DetailPageTabFormSection>
				);
			})}
		</>
	);
};

export { DetailPageTabPlaceholder };
